import { render, staticRenderFns } from "./OrderBumpForm.vue?vue&type=template&id=041c228e"
import script from "./OrderBumpForm.vue?vue&type=script&lang=js"
export * from "./OrderBumpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports